import type CK from '~/types/contentking';

import useBatchContext from '~/hooks/useBatchContext';



function useBatchContextPagesGraphs(
	websiteId: CK.WebsiteId | null,
) {
	return useBatchContext(
		`pagesGraphs/${websiteId ?? ''}`,
		999,
	);
}



export default useBatchContextPagesGraphs;
